/**
 * Support chart tab: monthly check-ins, dose and stack requests, and Dr.
 * Hinds' answer, so support can tell a patient why a dose did or didn't
 * change. The same view mounts in the clinician chart drawer.
 */
import { Link } from 'react-router-dom';

import { CareTeamNotes } from '@/features/clinician/CareTeamNotes';
import { CheckinDoseHistoryView } from '@/features/clinician/CheckinDoseHistory';
import { useClinicalCheckinDoseHistory } from '@/lib/api/clinicalAdminHooks';

import { ErrorState, LoadingState } from './ui';

export function CheckinDoseHistoryTab({ patientId }: { patientId: string }) {
  const { data, isLoading, isError } = useClinicalCheckinDoseHistory(patientId);
  return (
    <div className="flex flex-col gap-15">
      {/* Notes are their own read: a check-in outage must not hide them. */}
      <CareTeamNotes patientId={patientId} surface="admin" />
      {isLoading ? (
        <LoadingState label="Loading check-ins…" />
      ) : isError || !data ? (
        <ErrorState>Could not load check-ins and dose changes.</ErrorState>
      ) : (
        <CheckinDoseHistoryView
          data={data}
          openCheckin={
            <Link to="?tab=intake" className="type-label-sm underline">
              View full check-in
            </Link>
          }
        />
      )}
    </div>
  );
}
